import PropTypes from 'prop-types';

/**
 * PageShell — shared wrapper around the main content area for every protected
 * page in the app. Applies uniform horizontal/top padding AND a responsive
 * bottom spacer that clears the mobile dock and leaves room for a future
 * persistent session footer (GH #39).
 *
 * This component is rendered ONCE inside AppLayout (see App.jsx). Do NOT wrap
 * pages in it again and do NOT add per-page bottom padding to clear the dock
 * — that is the whole point of this shell.
 *
 * Responsive strategy:
 *   < lg (mobile / tablet): dock is visible (MobileDock uses `lg:hidden`),
 *     so reserve ~10rem (pb-40) to clear dock (≈64px) + session footer
 *     (≈64px) + a small breathing margin.
 *   lg+ (desktop): dock is hidden, sidebar is used instead, so reserve only
 *     ~2rem (pb-8) — enough for a desktop session footer to sit at bottom-0
 *     without jamming content.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children  Page content.
 * @param {string} [props.className]        Optional extra class names (merged, not replaced).
 */
const PageShell = ({ children, className = '' }) => (
  <main
    data-testid="page-shell"
    className={`p-4 lg:p-6 min-w-0 pb-40 lg:pb-8 ${className}`.trim()}
  >
    {children}
  </main>
);

PageShell.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default PageShell;
